import {
  Button, Dialog, DialogFooter, DialogHeader, DialogPanel, FeaturedIcon,
} from '@datanomik/core-ui';
import React from 'react';
import { t } from 'i18next';

import { UserForbidLine } from '@datanomik/core-ui/icons';

import { useAppContext } from '@/contexts/app';
import { useWorkspaceContext } from '@/contexts/workspace';
interface ForbiddenRawProps {
  className?: string;
}

const ForbiddenRaw = ({ className }: ForbiddenRawProps) => {
  const { handleResetStatus } = useAppContext();
  const { workspace: { redirectHome } } = useWorkspaceContext();

  const handleRedirect = () => {
    handleResetStatus();
    redirectHome();
  };

  return (
    <Dialog open>
      <DialogPanel className={className} size="xs" mandatory>
        <DialogHeader
          className="pr-6"
          icon={<FeaturedIcon size="md"><UserForbidLine /></FeaturedIcon>}
          title={t("It appears you don't have permissions to access this page")}
        />
        <DialogFooter>
          <Button onClick={handleRedirect} className="w-full">
            {t('Back to home page')}
          </Button>
        </DialogFooter>
      </DialogPanel>
    </Dialog>
  );
};
export default ForbiddenRaw;
